import { useContext } from "react";
import { SkeletonContext } from "./skeleton-context";

export const useSkeletonContext = () => {
  const context = useContext(SkeletonContext);

  if (!context) {
    throw new Error(
      "useSkeletonContext must be used within a SkeletonContextProvider",
    );
  }

  return context;
};
